import { ColorPaletteProp } from '@healthinal/ui';
import {
  SetTracingContactAssessmentResultDtoResult,
  TracingContactDetailsDtoAssessmentStatus,
} from '../api/generated/model';

export function getTracingContactAssessmentStatusName(status: TracingContactDetailsDtoAssessmentStatus) {
  if (status == null) {
    return '-';
  }
  switch (status) {
    case TracingContactDetailsDtoAssessmentStatus.PENDING:
      return 'Einschätzung nötig';
    case TracingContactDetailsDtoAssessmentStatus.NOT_NEEDED:
      return 'Kein Contact Tracing nötig';
    case TracingContactDetailsDtoAssessmentStatus.WAITING_PERIOD:
      return 'Wartefrist aktiv';
    case TracingContactDetailsDtoAssessmentStatus.APPOINTMENT_VISIT:
      return 'Termin';
    case TracingContactDetailsDtoAssessmentStatus.RESULT_INDETERMINATE:
      return 'Unbestimmt';
    case TracingContactDetailsDtoAssessmentStatus.RESULT_NEGATIVE:
      return 'Negativ';
    case TracingContactDetailsDtoAssessmentStatus.RESULT_POSITIVE:
      return 'Positiv';
    case TracingContactDetailsDtoAssessmentStatus.NO_UU_NEEDED:
      return 'keine UU nötig';
    case TracingContactDetailsDtoAssessmentStatus.RESULT_INFECTED:
      return 'Infiziert';
    case TracingContactDetailsDtoAssessmentStatus.RESULT_NOT_INFECTED:
      return 'Nicht infiziert';
    case TracingContactDetailsDtoAssessmentStatus.RESULT_SICK:
      return 'Erkrankt';
    case TracingContactDetailsDtoAssessmentStatus.NOT_SHOW_UP:
      return 'Nicht erschienen';
    case TracingContactDetailsDtoAssessmentStatus.REFUSED_TEST:
      return 'Test verweigert';
    case TracingContactDetailsDtoAssessmentStatus.GONE_HIDING:
      return 'Untergetaucht';
    case TracingContactDetailsDtoAssessmentStatus.STATUS_AFTER_TB:
      return 'Status nach TB';
    case TracingContactDetailsDtoAssessmentStatus.STATUS_AFTER_TBI:
      return 'Status nach TBI';
    case TracingContactDetailsDtoAssessmentStatus.INCUBATION_PERIOD:
      return 'Inkubationszeit';
  }
}

export function getTracingContactAssessmentStatusColor(
  type: TracingContactDetailsDtoAssessmentStatus,
): ColorPaletteProp {
  switch (type) {
    case TracingContactDetailsDtoAssessmentStatus.PENDING:
      return 'danger';
    case TracingContactDetailsDtoAssessmentStatus.WAITING_PERIOD:
      return 'warning';
    case TracingContactDetailsDtoAssessmentStatus.NOT_NEEDED:
    case TracingContactDetailsDtoAssessmentStatus.RESULT_INDETERMINATE:
    case TracingContactDetailsDtoAssessmentStatus.RESULT_NEGATIVE:
    case TracingContactDetailsDtoAssessmentStatus.RESULT_POSITIVE:
      return 'primary';
    default:
      return 'neutral';
  }
}

export function getTracingContactAssessmentResultFromStatus(
  status: NonNullable<TracingContactDetailsDtoAssessmentStatus>,
): SetTracingContactAssessmentResultDtoResult | null {
  switch (status) {
    case TracingContactDetailsDtoAssessmentStatus.NO_UU_NEEDED:
      return SetTracingContactAssessmentResultDtoResult.NO_UU_NEEDED;
    case TracingContactDetailsDtoAssessmentStatus.RESULT_INFECTED:
      return SetTracingContactAssessmentResultDtoResult.INFECTED;
    case TracingContactDetailsDtoAssessmentStatus.RESULT_NOT_INFECTED:
      return SetTracingContactAssessmentResultDtoResult.NOT_INFECTED;
    case TracingContactDetailsDtoAssessmentStatus.RESULT_SICK:
      return SetTracingContactAssessmentResultDtoResult.SICK;
    case TracingContactDetailsDtoAssessmentStatus.NOT_SHOW_UP:
      return SetTracingContactAssessmentResultDtoResult.NOT_SHOW_UP;
    case TracingContactDetailsDtoAssessmentStatus.REFUSED_TEST:
      return SetTracingContactAssessmentResultDtoResult.REFUSED_TEST;
    case TracingContactDetailsDtoAssessmentStatus.GONE_HIDING:
      return SetTracingContactAssessmentResultDtoResult.GONE_HIDING;
    case TracingContactDetailsDtoAssessmentStatus.STATUS_AFTER_TB:
      return SetTracingContactAssessmentResultDtoResult.STATUS_AFTER_TB;
    case TracingContactDetailsDtoAssessmentStatus.STATUS_AFTER_TBI:
      return SetTracingContactAssessmentResultDtoResult.STATUS_AFTER_TBI;
    default:
      return null;
  }
}

export function getTracingContactAssessmentResultName(result: SetTracingContactAssessmentResultDtoResult) {
  switch (result) {
    // case SetTracingContactAssessmentResultDtoResult.NOT_NEEDED:
    //   return 'Kein Contact Tracing nötig';
    // case SetTracingContactAssessmentResultDtoResult.INDETERMINATE:
    //   return 'Unbestimmt';
    // case SetTracingContactAssessmentResultDtoResult.NEGATIVE:
    //   return 'Negativ';
    // case SetTracingContactAssessmentResultDtoResult.POSITIVE:
    //   return 'Positiv';
    case SetTracingContactAssessmentResultDtoResult.NO_UU_NEEDED:
      return 'keine UU nötig';
    case SetTracingContactAssessmentResultDtoResult.INFECTED:
      return 'Infiziert';
    case SetTracingContactAssessmentResultDtoResult.NOT_INFECTED:
      return 'Nicht infiziert';
    case SetTracingContactAssessmentResultDtoResult.SICK:
      return 'Erkrankt';
    case SetTracingContactAssessmentResultDtoResult.NOT_SHOW_UP:
      return 'Nicht erschienen';
    case SetTracingContactAssessmentResultDtoResult.REFUSED_TEST:
      return 'Test verweigert';
    case SetTracingContactAssessmentResultDtoResult.GONE_HIDING:
      return 'Untergetaucht';
    case SetTracingContactAssessmentResultDtoResult.STATUS_AFTER_TB:
      return 'Status nach TB';
    case SetTracingContactAssessmentResultDtoResult.STATUS_AFTER_TBI:
      return 'Status nach TBI';
  }
}
